import { FieldProps } from 'formik'
import {
  FormikChoiceGroup,
  FormikTextField,
} from 'formik-office-ui-fabric-react'
import { FieldStack, FieldStackItem, FormStack } from 'forms/FormStack'
import { IChoiceGroupOption, Label } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { useGetKeywordListsQuery } from 'views/AdminKeywordsView/AdminKeywordsView.generated'

interface OptionsSettings {
  options: string[]
  type: string
  __typename: string
}
export const ProvingDetailsGeneralDeclineProvingForm: React.FC = () => {
  const { t } = useTranslation()
  const { data } = useGetKeywordListsQuery()
  let items: string[] = []
  const dataItems: OptionsSettings[] =
    data && data.globalSettings
      ? (data.globalSettings as OptionsSettings[])
      : []
  if (dataItems.length !== 0) {
    dataItems.forEach((setting) => {
      if (setting.type === 'declineReasons' && setting.options) {
        items = setting.options
      }
    })
  }

  const options: IChoiceGroupOption[] = [
    ...items.map(
      (item: string, i) =>
        ({
          key: item,
          text: item,
        } as IChoiceGroupOption)
    ),
  ]

  // const options: IChoiceGroupOption[] = [
  //   {
  //     key: `${t('field.declineReason.label.noParticipants')}`,
  //     text: t('Keine Teilnehmer vorhanden2'),
  //   },
  //   {
  //     key: `${t('field.declineReason.label.noVehicles')}`,
  //     text: t('Keine Fahrzeuge vorhanden'),
  //   },
  //   {
  //     key: `${t('field.declineReason.label.noAccomodations')}`,
  //     text: t('Keine Unterkünfte vorhanden'),
  //   },
  //   {
  //     key: `${t('field.declineReason.label.noProvingReason')}`,
  //     text: t('Erprobungsgrund ist nicht gegeben'),
  //   },
  //   {
  //     key: `${t('field.declineReason.label.nmfNotAvailable')}`,
  //     text: t('Mobile Ladeinfrastruktur steht nicht zur Verfügung'),
  //   },
  //   {
  //     key: `${t('field.declineReason.label.onlyWvtDvt')}`,
  //     text: t(
  //       'Erprobungen mit ausschließlich WVT-/DVT-Teilnehmern dürfen nicht gebucht werden - Rechtliche Vorgabe: Die Organisation muss durch das WVT-/DVT-Unternehmen selbständig durchgeführt werden. Bitte beachten Sie hierzu das Dokument "Information Reiseorganisation von externen Dienstleistern ab September 2017 im EMOS" unter "Infos für Antragsteller"'
  //     ),
  //   },
  //   {
  //     key: `${t('field.declineReason.label.consulting')}`,
  //     text: t(
  //       'Bitte melden Sie sich zur Rücksprache bei Sascha Niesen - Tel.: 85899. Vielen Dank!'
  //     ),
  //   },
  // ]

  return (
    <FormStack>
      <FieldStack>
        <Label>{t('Begründung auswählen')}</Label>
        <FieldStackItem
          name="declineReason"
          render={(fieldProps: FieldProps<any>) => (
            <FormikChoiceGroup {...fieldProps} options={options} />
          )}
        />
        <FieldStackItem
          name="declineReason"
          render={(fieldProps: FieldProps<any>) => (
            <FormikTextField {...fieldProps} />
          )}
        />
      </FieldStack>
    </FormStack>
  )
}
